export default "__VITE_ASSET__bbd3d04f__"